import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=41c1fd8b&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=41c1fd8b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c1fd8b",
  null
  
)

export default component.exports